import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { replaceImagePath } from '../../../lib/media-path-replacer';
import Accordion from '../../accordion';
import { Body } from '../../typography';

const Container = styled.div`
    padding-bottom: 16px;

    & > div:not(:last-child) {
        margin-bottom: 8px;
    }
`;

export const ImagesContainer = styled.div`
    & > img {
        display: block;
        width: 100%;
    }

    & > img:not(:last-child) {
        margin-bottom: 8px;
    }
`;

const DEFAULT_TITLE = 'Definizione';

export const parseDefinition = (definitions) => {
    const parser = new DOMParser();

    const result = [];

    for (let i = 0; i < definitions.length; i++) {
        const currentDefinition = definitions[i].xml;
        const document = parser.parseFromString(currentDefinition, 'application/xml');
        const parsedPublicTitle = document.getElementsByTagName('public_title')[0];

        let publicTitle;
        if (parsedPublicTitle && parsedPublicTitle.textContent) {
            publicTitle = parsedPublicTitle.textContent;
        } else {
            publicTitle = `${DEFAULT_TITLE} ${i + 1}`;
        }

        const iterator = document.evaluate('//question//img/@src', document, null, XPathResult.ANY_TYPE, null);

        const definitionsJSON = [];
        let thisSrc = iterator.iterateNext();
        while (thisSrc) {
            definitionsJSON.push({ src: replaceImagePath(thisSrc.nodeValue) });
            thisSrc = iterator.iterateNext();
        }

        result.push({ title: publicTitle, content: definitionsJSON });
    }

    return result;
};

const DefinitionType = ({ definitions }) => {
    const parsedDefinitions = parseDefinition(definitions);

    return (
        <Container>
            {parsedDefinitions.map((definition, index) => {
                return (
                    <Accordion key={index}>
                        <Body lv={4} fontWeight="semi-bold">
                            {definition.title}
                        </Body>
                        <ImagesContainer>
                            {definition.content.map((content, indexImages) => {
                                return <img key={indexImages} src={content.src} alt="Immagine definizione" />;
                            })}
                        </ImagesContainer>
                    </Accordion>
                );
            })}
        </Container>
    );
};

DefinitionType.propTypes = {
    definitions: PropTypes.array,
};

export default DefinitionType;
